import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { CustomValueScope } from "PFTypes";

import { CustomValuePreviewContextProvider } from "./context/custom_value_preview_context_provider";
import { useCustomValuePreviewData } from "./use_custom_value_preview";
import { ActivityCustomValuePreview } from "./views/activity_custom_value_preview";
import { ProfileCustomValuePreview } from "./views/profile_custom_value_preview";

export const CustomValuePreview = () => {
  const { getCustomTypeById } = useCustomTypes();

  const {
    data: { customTypeId, scope }
  } = useCustomValuePreviewData();

  const customType = getCustomTypeById(customTypeId);

  if (!customType || ![CustomValueScope.Activity, CustomValueScope.Profile].includes(scope)) {
    return null;
  }

  return (
    <CustomValuePreviewContextProvider customType={customType}>
      {scope === CustomValueScope.Activity && <ActivityCustomValuePreview />}
      {scope === CustomValueScope.Profile && <ProfileCustomValuePreview />}
    </CustomValuePreviewContextProvider>
  );
};
